import { Button, Stack, ThemeColorVariable, ThemeRadiusVariable } from "@caspeco/casper-ui-library";
import { error as logError } from "logger/logger";
import { useState } from "react";

interface IContinueButton {
    buttonText: string;
    onContinue: () => Promise<void> | void;
    isDisabled?: boolean;
    key?: string;
    trackingId?: string;
}

/**
 * The button that continues the user flow from preorder to the next step
 * Shared by both the modal and panel version of the preorder component
 */
const ContinueButton = ({
    buttonText,
    onContinue,
    isDisabled = false,
    trackingId,
}: IContinueButton) => {
    const [loading, setLoading] = useState(false);
    const handleOnClick = async () => {
        setLoading(true);
        try {
            await onContinue();
        } catch (error: unknown) {
            logError("Error", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Stack
            bg={ThemeColorVariable.Background}
            w="100%"
            borderRadius={ThemeRadiusVariable.XLarge}
        >
            <Button
                variant="primary"
                size="xl"
                alignSelf="flex-end"
                w="full"
                isLoading={loading}
                isDisabled={isDisabled}
                onClick={() => {
                    void handleOnClick();
                }}
                data-track-click={trackingId}
                zIndex={99}
            >
                {buttonText}
            </Button>
        </Stack>
    );
};

export default ContinueButton;
